var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisaPaymentBlack = function SvgVisaPaymentBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.574 18.998h-2.671l1.67-9.696h2.671zm9.682-9.458a7 7 0 0 0-2.396-.413c-2.637 0-4.495 1.32-4.506 3.207-.022 1.393 1.33 2.167 2.34 2.631 1.034.475 1.385.784 1.385 1.207-.01.65-.835.95-1.604.95-1.066 0-1.638-.155-2.506-.517l-.352-.154-.373 2.176c.626.268 1.78.506 2.979.516 2.802 0 4.627-1.3 4.649-3.311.01-1.104-.704-1.95-2.243-2.64-.934-.444-1.506-.744-1.506-1.198.011-.412.484-.835 1.538-.835a4.8 4.8 0 0 1 1.99.371l.242.103z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M33.037 9.302h2.066L37.258 19h-2.473s-.242-1.115-.32-1.455h-3.429l-.56 1.454h-2.803l3.968-8.891c.275-.63.759-.805 1.396-.805Zm-.164 3.549-1.067 2.713h2.22c-.11-.485-.615-2.806-.615-2.806l-.187-.835a51 51 0 0 1-.351.928M4.33 9.302h4.297c.582.02 1.055.196 1.209.816l.932 4.449.002.006.286 1.341 2.616-6.612h2.825l-4.199 9.686H9.473l-2.38-8.424a11.3 11.3 0 0 0-2.808-1.066z",
    clipRule: "evenodd"
  })));
};
export default SvgVisaPaymentBlack;